// @flow
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import ImageWithFallback from '@liveauctioneers/caterwaul-components/lib/ImageWithFallback/ImageWithFallback';
import React from 'react';
import styles from './Mobile.module.scss';

type Props = {
    alternative?: boolean,
    mobileBrowserOS: string,
    mobileViewOnly?: boolean,
    windowWidth: number,
};

const Mobile = (props: Props) => {
    const { alternative, mobileBrowserOS, mobileViewOnly, windowWidth } = props;
    const isIOS = mobileBrowserOS === 'ios';
    const isMobile = windowWidth < 767 || mobileViewOnly;

    const displayIOS = (isIOS && isMobile) || !isMobile;
    const displayAndroid = (!isIOS && isMobile) || !isMobile;

    if (isMobile && !alternative) {
        return null;
    }

    const mobileFooterClass = classNames(styles.mobile, Boolean(isMobile) && styles.displayMobile);
    const insideClasses = classNames(Boolean(alternative) && styles.alternative, styles.inside);

    return (
        <div id="getMobileBanner" className={mobileFooterClass}>
            <div className={insideClasses}>
                {displayIOS && (
                    <ImageWithFallback
                        src="https://p1.liveauctioneers.com/dist/images/iPhoneXs_Download_Home.png"
                        alt="iphone"
                        className={classNames(styles.phoneImage, styles.iosPhoneImage)}
                    />
                )}
                {displayAndroid && (
                    <ImageWithFallback
                        src="https://p1.liveauctioneers.com/dist/images/Pixel3_Download_Home.png"
                        alt="androidPhone"
                        className={classNames(styles.phoneImage, styles.androidPhoneImage)}
                    />
                )}
                <div className={styles.alternativeGrouping}>
                    {alternative ? (
                        <div>
                            <div className={styles.title}>
                                <FormattedMessage id="treasure_hunt" />
                            </div>
                            <div className={styles.body}>
                                <FormattedMessage id="bid_on_items_added_daily" />
                            </div>
                        </div>
                    ) : (
                        <div className={styles.footerText}>
                            <FormattedMessage id="get_notifications_from_favorite_auctioneers" />
                        </div>
                    )}
                    <div className={styles.groupedBadges}>
                        {displayIOS && (
                            <a
                                className={styles.badge}
                                href="https://itunes.apple.com/us/app/live-auctions/id321243082"
                                target="blank"
                                title="Available on the App Store"
                            >
                                <ImageWithFallback
                                    style={{ height: 40, width: 120 }}
                                    src="https://p1.liveauctioneers.com/dist/images/app_store.svg"
                                    alt="mobile"
                                    className={styles.iosBadge}
                                />
                            </a>
                        )}
                        {displayAndroid && (
                            <a
                                className={styles.badge}
                                href="https://play.google.com/store/apps/details?id=com.liveauctioneers.and"
                                target="blank"
                                title="Android App on Google Play"
                            >
                                <ImageWithFallback
                                    style={{ height: 60, width: 155 }}
                                    src="https://p1.liveauctioneers.com/dist/images/google_play.png"
                                    alt="mobile"
                                    className={styles.googleBadge}
                                />
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo<Props>(Mobile);
